export default __webpack_public_path__ + "static/media/6.33f02f93.png";